module.exports = __webpack_public_path__ + "img/qr_fundo.36ffc4ab.png";